import type KubernetesAppName from '~/constants/common/KubernetesAppName';

export default function getBranchCookieName(appName: KubernetesAppName) {
  return `carvana-merch-${appName}-feature-name`;
}
